






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { getOperationID } from '@/api/operations'

@Component({})
export default class Avancement extends Vue {
    apiService = new ApiService()
    phasePercent: number = 0
    phase: number = 0

    async mounted() {
        const opeID = await getOperationID()
        const opeResp = await this.apiService.getOperation(opeID)
        const ope = opeResp.data
        this.phasePercent = ope.phasePercent
        this.phase = ope.phase
    }
}
